module.exports = __webpack_public_path__ + "static/media/shell.20f77fb8.jpg";